(function() {
  var __blocks__ = {};
  (function() {
    var element = document.getElementById("blocks-script");
    var attribute = a = element ? element.getAttribute("data-blocks") : '';
    var blocks = a.split(",").filter(Boolean);

    for (var i = 0; i < blocks.length; i++) {
      __blocks__[blocks[i]] = true;
    }
  })();
  (function() {
  if (!__blocks__["itc-product-description"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('itc-product-description')) {
    class ItcProductDescription extends HTMLElement {
      connectedCallback() {
        if (this.ready) return;
        this.ready = true;
        this.wrappers = [...this.querySelectorAll('table')].map((table) => {
          let wrap = table.parentElement;
          if (!wrap || wrap === this || wrap.querySelectorAll('table').length > 1) {
            wrap = document.createElement('div');
            table.before(wrap);
            wrap.append(table);
          }
          wrap.removeAttribute('style');
          wrap.classList.add('itc-desc__scroll');
          const hint = document.createElement('p');
          hint.className = 'itc-desc__hint';
          const cols = table.rows[0]?.cells.length - 1 || 0;
          hint.textContent = (this.dataset.hint || 'Swipe to compare all [n] models').replace('[n]', String(cols));
          hint.insertAdjacentHTML(
            'beforeend',
            '<svg aria-hidden="true" width="14" height="14" viewBox="0 0 14 14"><path d="M2 7h10M8 3l4 4-4 4" fill="none" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/></svg>'
          );
          wrap.before(hint);
          return { wrap, hint };
        });
        this.check = this.check.bind(this);
        this.resizeObserver = new ResizeObserver(this.check);
        this.wrappers.forEach(({ wrap }) => {
          this.resizeObserver.observe(wrap);
          wrap.addEventListener('scroll', this.check, { passive: true });
        });
        this.check();
      }

      disconnectedCallback() {
        this.resizeObserver?.disconnect();
      }

      check() {
        this.wrappers.forEach(({ wrap, hint }) => {
          const overflowing = wrap.scrollWidth - wrap.clientWidth > 2;
          wrap.classList.toggle('is-overflowing', overflowing && wrap.scrollLeft > 0);
          hint.classList.toggle('is-visible', overflowing);
        });
      }
    }

    customElements.define('itc-product-description', ItcProductDescription);
  }
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__blocks__["itc-quote-button"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('itc-quote-action')) {
    class ItcQuoteAction extends HTMLElement {
      connectedCallback() {
        if (this.ready) return;
        this.ready = true;
        this.links = [...this.querySelectorAll('[data-itc-quote-link]')];
        this.model = this.querySelector('[data-itc-quote-model]');
        this.bar = this.querySelector('[data-itc-quote-bar]');
        try {
          this.variants = JSON.parse(this.querySelector('[data-itc-quote-variants]')?.textContent || '{}');
        } catch (error) {
          this.variants = {};
        }

        this.update = this.update.bind(this);
        this.onChange = (event) => {
          if (event.target instanceof Element && event.target.closest('variant-picker')) {
            setTimeout(this.update, 0);
          }
        };
        document.addEventListener('change', this.onChange);
        this.links.forEach((link) => link.addEventListener('click', this.update));
        this.update();

        if (this.bar && 'IntersectionObserver' in window) {
          this.observer = new IntersectionObserver(([entry]) => {
            const show = !entry.isIntersecting && entry.boundingClientRect.top < 0;
            this.bar.classList.toggle('is-visible', show);
            this.bar.setAttribute('aria-hidden', String(!show));
            this.bar.querySelector('a')?.setAttribute('tabindex', show ? '0' : '-1');
          });
          this.observer.observe(this.links[0]);
        }
      }

      disconnectedCallback() {
        document.removeEventListener('change', this.onChange);
        this.observer?.disconnect();
      }

      currentVariantId() {
        const scope = this.closest('.product-details, product-information, main') || document;
        const picked = scope.querySelector(
          'variant-picker input:checked[data-variant-id], variant-picker option:checked[data-variant-id]'
        );
        if (picked?.dataset.variantId) return picked.dataset.variantId;
        const fromUrl = new URLSearchParams(window.location.search).get('variant');
        if (fromUrl && this.variants[fromUrl]) return fromUrl;
        return this.dataset.defaultVariant;
      }

      update() {
        const id = this.currentVariantId();
        const title = this.variants[id];
        const url = new URL(this.dataset.baseUrl, window.location.origin);
        if (title) {
          url.searchParams.set('model', title);
          url.searchParams.set('variant', id);
        }
        const href = url.pathname + url.search;
        this.links.forEach((link) => link.setAttribute('href', href));
        if (this.model && title) this.model.textContent = title;
      }
    }

    customElements.define('itc-quote-action', ItcQuoteAction);
  }
  } catch(e) { console.error(e); }
})();

})();
